import type {
  IRequestDetailApi,
  IRequestsApiResponse
} from '@/shared/types/requests-api.types';

import { ApiConnector } from './api.connector';

class RequestsApi extends ApiConnector {
  getRequests(params?: IGetRequestsParams): Promise<IRequestsApiResponse> {
    return this.call({
      path: 'client-portal/requests',
      params
    });
  }

  getRequestByUuid(requestUuid: string): Promise<IRequestDetailApi> {
    return this.call({ path: `client-portal/requests/${requestUuid}` });
  }

  respondToOffer(body: IOfferRespondRequestApi): Promise<void> {
    return this.call({
      path: 'client-portal/offer/respond',
      method: 'post',
      body
    });
  }
}

export const requestsApi = new RequestsApi();

export interface IGetRequestsParams {
  limit?: number;
  offset?: number;
}

export type TOfferClientStatus = 'approved_by_client' | 'declined';

export interface IOfferRespondRequestApi {
  decision_uuid: string;
  status: TOfferClientStatus;
}
